import React from 'react'
import styled from 'styled-components'
import { STYLES } from '../../static/style'
import { Badge } from '../../components/Badge'
import { SchoolSectors } from '@laputan/core/dist/types/School.types'

const StyledSectorBadge = styled(Badge).attrs({
  title: 'Sector',
  titleBackgroundColor: STYLES.COLOR_ALANTIS_GREEN,
  textBackgroundColor: '#dce8bb',
})``

interface ISectorBadgeProps {
  className?: string
  children: SchoolSectors
}

const SectorBadge: React.FC<ISectorBadgeProps> = ({ className, children }) => (
  <StyledSectorBadge className={className}>{children}</StyledSectorBadge>
)

export { SectorBadge }
